<template>
  <div>
    <v-toolbar color="page-toolbar">
      <v-toolbar-title class="text-body-large"> Liste des Partenaires <small>(Administration)</small> </v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-btn class="fab-absolute-top-right" color="success" @click="$router.push({ name: 'admin-partner-add' })" icon size="large">
        <v-icon> mdi-plus </v-icon>
      </v-btn>
      <v-card-title class="d-flex flex-wrap align-center ga-2">
        Partenaires
        <v-spacer></v-spacer>
        <v-btn v-if="typeFilter" icon size="small" @click="clearFilter">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-title>
      <!-- The table's loading slot is never rendered here because the draggable list replaces the whole body -->
      <v-skeleton-loader v-if="loadingPartners" type="table-thead, table-row@6"></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="filteredPartners"
        :items-per-page="-1"
        no-data-text="Aucun partenaire disponible"
        items-per-page-text="Éléments par page"
        hide-default-body
      >
        <!-- The draggable list is the <tbody> itself; the body slot would nest it inside the table's own <tbody> -->
        <template v-slot:tbody>
          <draggable v-model="partners" item-key="id" tag="tbody" @end="onRowMove">
            <template #item="{ element: item }">
              <tr>
                <td>{{ item.order }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.description }}</td>
                <td><img :src="item.image" alt="Image" width="50" /></td>
                <td>
                  <v-icon v-if="item.active" color="green">mdi-check</v-icon>
                  <v-icon v-else color="red">mdi-close</v-icon>
                </td>
                <td>
                  <v-chip v-if="item.isPaying" size="x-small" color="gold-tint" variant="flat">Payant</v-chip>
                  <span v-else class="text-grey-lighten-1">—</span>
                </td>
                <td>
                  <v-icon size="small" class="mr-2" @click="editPartner(item)" color="primary">mdi-pencil</v-icon>
                </td>
              </tr>
            </template>
          </draggable>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import draggable from "vuedraggable";

  export default {
    components: {
      draggable,
    },
    data() {
      return {
        search: "",
        typeFilter: null,
        headers: [
          { title: "Ordre", key: "order", sortable: false },
          { title: "Nom", align: "start", key: "name" },
          { title: "Description", key: "description" },
          { title: "Image", key: "image" },
          { title: "Actif", key: "active" },
          { title: "Payant", key: "isPaying" },
          { title: "Action", key: "actions" },
        ],
        partners: [],
        loadingPartners: true,
      };
    },
    async created() {
      try {
        await this.$store.dispatch("PartnersService/bindPartners");
      } finally {
        this.loadingPartners = false;
      }
    },
    watch: {
      "$store.state.PartnersService.partners": {
        immediate: true,
        handler(newPartners) {
          this.partners = this.sortPartners(newPartners);
        },
      },
    },
    computed: {
      filteredPartners() {
        if (!this.typeFilter) return this.partners;
        return this.partners.filter((partner) => partner.type === this.typeFilter);
      },
    },
    methods: {
      editPartner(partner) {
        if (!partner || !partner.id || typeof partner.id !== "string" || partner.id.trim() === "") {
          console.error("Invalid partner id for edit:", partner);
          return;
        }
        const slug = partner.id;
        this.$router.push({ name: "admin-partner-edit", params: { slug, partner } });
      },
      clearFilter() {
        this.typeFilter = null;
      },
      sortPartners(partners) {
        return [...partners].sort((a, b) => {
          const aHasOrder = typeof a.order === "number";
          const bHasOrder = typeof b.order === "number";

          if (aHasOrder && bHasOrder && a.order !== b.order) {
            return a.order - b.order;
          }

          if (aHasOrder && !bHasOrder) return -1;
          if (!aHasOrder && bHasOrder) return 1;

          return (a.name || "").localeCompare(b.name || "");
        });
      },
      onRowMove() {
        const reorderedPartners = this.partners.map((item, index) => ({
          ...item,
          order: index + 1,
        }));
        this.saveOrder(reorderedPartners);
      },
      async saveOrder(partners) {
        await this.$store.dispatch("PartnersService/updatePartnerOrder", partners);
      },
    },
  };
</script>
